/* Shirts Frenzy — reveal-on-scroll. Adds .in to .sf-skin .reveal elements
   when they enter the viewport ("in and stay"). Mirrors the prototype's
   Reveal component. Falls back to showing everything if IO is unavailable. */
(function () {
  function show(el) { el.classList.add('in'); }

  function bind(root) {
    var els = (root || document).querySelectorAll('.sf-skin .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(show);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { bind(document); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Theme-editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
